import React, { memo, useCallback } from 'react';
import { Link } from 'js/components/common/Link';
import { Icon } from 'js/components/common/Icon';
import { usePortletDispatch, usePortletTranslations } from 'js/components/system/Portlet';
import { setExpandedCategoryAction } from 'js/components/main/Games/actions';
import style from './index.scss';
import { useDeviceSelector } from 'js/store/hooks';
import { compose, prop } from 'ramda';
import { onlyUpdateForKeys } from 'recompose';
import { useExpandedPopup } from '../../../popups/ExpandedCategoryGamesPopup/hooks';
export const ViewMoreWithExpanded = memo(({
                                              expanded,
                                              cid,
                                              count,
                                              gameCodes,
                                              displayName,
                                              isRecommendedCategory,
                                              formatCategoryName,
                                              mostPlayedGame
                                          }) => {
    const t = usePortletTranslations();
    const dispatch = usePortletDispatch();
    const onClick = useCallback(() => dispatch(setExpandedCategoryAction(cid)), [cid, dispatch]);
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const showExpandedPopup = useExpandedPopup(
        cid,
        gameCodes,
        displayName,
        isRecommendedCategory,
        formatCategoryName,
        mostPlayedGame
    );

    if (!isDesktop) {
        return <Link className={style.toggleAllGames} onClick={showExpandedPopup}>
            {t('games.showAll')} {`(${count})`}
        </Link>;
    }

    return <Link className={style.toggleAllGames} onClick={onClick}>
        {t(`games.${expanded ? 'viewLess' : 'viewMore'}`)}
        <Icon type="showMoreArrow" className={style.icon} />
    </Link>;
});

export default compose(
    onlyUpdateForKeys(['expanded', 'count'])
)(ViewMoreWithExpanded);
